import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import Grid from '@material-ui/core/Grid';
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbBrandLinkRowBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`brand-link-grid ${props.attributes.className ? props.attributes.className : ''} ${classes.brandLinkRow} ${classes.brandLinkRowTheme}`}>
        <Grid container spacing={3} direction="row">
            <Grid item xs={12} >
                {blocks[0]}
            </Grid>
            <Grid item xs={12} >
                <div className="brand-links">
                    {blocks[1]}
                    {blocks[2]}
                    {blocks[3]}
                    {blocks[4]}
                </div>
            </Grid>
        </Grid>
    </div>
};

export const CgbBrandLinkRowBlockFragment = graphql`
  fragment CgbBrandLinkRowBlock on WpBlock {
    ... on WpCgbBrandLinkRowBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbBrandLinkRowBlockPreview = `
    ... on CgbBrandLinkRowBlock {
        name
        attributes {
            className
        }
    }
`;